export const boardGanttTour = {
  key: "boardGantt",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-gantt-taskrows"]',
      content: t("Tour_BoardGantt_TaskRows"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "body",
      content: t("Tour_BoardGantt_Drag"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-gantt-zoom"]',
      content: t("Tour_BoardGantt_Zoom"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-gantt-toolbar"]',
      content: t("Tour_BoardGantt_Toolbar"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-gantt-addsubtask"]',
      content: t("Tour_BoardGantt_AddSubtask"),
      placement: "left",
    },
  ],
};
